module.exports = __webpack_public_path__ + "static/media/math-olympaid-logo_thumbnail.b9d972e0.png";